import React from 'react';
import {useTranslation} from 'react-i18next';
import DashboardLayout from "../../layouts/DashboardLayout";
import PageHeader from "../../components/PageHeader";
import Activate2FA from "../../components/Activate2FA";

function Profile() {
    const {t} = useTranslation();

    return (
        <DashboardLayout>
            <PageHeader
                title={t('account.profile', {defaultValue: 'Profile'})}
                description={t('account.profile_description', {defaultValue: 'Manage your profile and security settings'})}
            />

            <form>
                <div className="mt-8 space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
                    <div className="bg-white/60 backdrop-blur-md rounded-[2rem] shadow-sm border border-gray-100 p-8">
                        <h2 className="text-base font-semibold leading-7 text-gray-900">{t('_.security', {defaultValue: 'Security'})}</h2>
                        <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-600">
                            {t('account.security_description', {defaultValue: 'Protect your account and personal information by configuring critical security settings in this section.'})}
                        </p>
                        <div className="mt-6">
                            <Activate2FA/>
                        </div>
                    </div>

                    <div className="bg-white/60 backdrop-blur-md rounded-[2rem] shadow-sm border border-gray-100 p-8">
                        <h2 className="text-base font-semibold leading-7 text-gray-900">{t('_.notifications', {defaultValue: 'Notifications'})}</h2>
                        <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-600">
                            {t('account.notifications_description', {defaultValue: "We'll always let you know about important changes, but you pick what else you want to hear about."})}
                        </p>

                        <div className="mt-8 space-y-6">
                            <fieldset>
                                <legend className="sr-only">By Email</legend>
                                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:py-2">
                                    <div className="text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
                                        {t('_.by_email', {defaultValue: 'By Email'})}
                                    </div>
                                    <div className="mt-4 sm:col-span-2 sm:mt-0">
                                        <div className="max-w-lg space-y-6">
                                            <div className="relative flex gap-x-3">
                                                <div className="flex h-6 items-center">
                                                    <input
                                                        id="payments"
                                                        name="payments"
                                                        type="checkbox"
                                                        className="h-4 w-4 rounded border-gray-300 text-cyan-500 focus:ring-blue-500"
                                                    />
                                                </div>
                                                <div className="text-sm leading-6">
                                                    <label htmlFor="payments" className="font-medium text-gray-900">
                                                        {t('_.paid_payments', {defaultValue: 'Paid payments'})}
                                                    </label>
                                                    <p className="mt-1 text-gray-600">{t('_.paid_payments_desc', {defaultValue: 'Receive notifications when payments for invoices have been successfully processed.'})}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </form>
        </DashboardLayout>
    );
}

export default Profile;
